const Text = (props) => {
  const { color, fontSize, fontWeight, children } = props;
  return <span style={{ color, fontSize, fontWeight }}>{children}</span>;
};

export default Text;
